module.exports = __webpack_public_path__ + "static/man-explaining.56eee062.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/man-explaining.svg
// module id = 462
// module chunks = 35783957827783